import React from 'react';

import { QuestionBubble } from '../QuestionBubble';
import HelpLink from '../../HelpLink/HelpLink';
import { TestID, visitProviderKnowledgeCenterLinkClassName } from './constants';

const HPICoverageQuestionBubble: React.FC = () => (
  <QuestionBubble
    dataTestID={TestID}
    popoverSubtitle="Employer Insurance"
    popoverTitle="Health Plan Integration (HPI)"
    sections={[
      {
        sectionTitle: 'What is HPI eligibility?',
        sectionBody: (
          <div>
            Once clients have used their employer-sponsored sessions, they can continue care with a
            Modern Health therapist through their health plan. If their employer offers this
            benefit, clients can validate their eligibility by submitting their health insurance
            information.
          </div>
        ),
      },
      {
        sectionTitle: 'What do these terms mean?',
        sectionBody: (
          <>
            <div>
              <span className="font-bold">Eligible:</span> Once health insurance information is
              confirmed, a client may be deemed HPI eligible. HPI eligibility gives members
              continued access to therapy sessions through Modern Health.
            </div>

            <div className="mt-4">
              <span className="font-bold">Not eligible:</span> The client is not covered for
              continued therapy sessions. For example, they may not be eligible because their
              company does not offer HPI or their insurance plan has limited coverage and does not
              cover mental health services.
            </div>

            <div className="mt-4">
              <span className="font-bold">Incomplete:</span> If an employer offers the HPI benefit
              but the client doesn't complete their form, their HPI eligibility status will remain
              incomplete, meaning it cannot be verified whether they can access continued therapy
              sessions.
            </div>
          </>
        ),
      },
      {
        sectionBody: (
          <HelpLink className={visitProviderKnowledgeCenterLinkClassName}>
            Visit Provider Knowledge Center
          </HelpLink>
        ),
      },
    ]}
  />
);

export default HPICoverageQuestionBubble;
